import axios from 'axios';
import { endpoints } from '../utils/constants';

export const switchDivision = ({ userId, divisionCode, token }) => {
  const requestBody = {
    userId,
    division: divisionCode,
    token,
  };
  return axios.post(endpoints.sitecore.switchDivision, requestBody, {});
};

export const getUser = (userId, divisionCode, token) => {
  const requestBody = {
    userId,
    division: divisionCode,
    token,
  };
  return axios.post(endpoints.sitecore.getUser, requestBody, {});
};
